import React, { FC, useCallback, useMemo } from 'react';

import classNames from 'classnames';
import Autocomplete from 'react-google-autocomplete';

import { useTranslation } from 'react-i18next';
import { environment } from '../../environments/environment';

import { IGooglePlaceResult } from '../../models';

import { IAddressAutocomplete } from './model';
import { getParsedAddressFromGooglePlace } from './utils';
import { InputWrapper, Label, Wrapper } from './styles';
import formatAddress from '../../utils/formatAddress';

export const AddressAutocomplete: FC<IAddressAutocomplete> = (props) => {
  const { t } = useTranslation();

  const {
    onSelectAddress,
    className,
    handleBlur,
    label = t('Address'),
    initialValue,
    isRequired,
    value,
  } = props;

  const parsedInitialValue = useMemo(() => formatAddress(
    initialValue
  ), [initialValue]);

  const handleAddressSelect = useCallback(
    (place: IGooglePlaceResult) => {
      onSelectAddress(getParsedAddressFromGooglePlace(place));
    },
    [onSelectAddress]
  );

  const handleManualAddress = useCallback(
    (address: string) => {
      if (!address.length) {
        onSelectAddress(null);
        return;
      }

      onSelectAddress({ address });
    },
    [onSelectAddress]
  );

  return (
    <Wrapper>
      <Label>
        {isRequired && <span>*</span>}
        {label}
      </Label>
      <InputWrapper className={classNames('address-autocomplete', className)}>
        <Autocomplete
          apiKey={environment.googleMapsAPIKey}
          onPlaceSelected={(p) => handleAddressSelect(p)}
          onChange={(e) =>
            handleManualAddress((e.target as HTMLInputElement).value)
          }
          onBlur={() => handleBlur()}
          defaultValue={parsedInitialValue}
          options={{
            types: ['address'],
            fields: ['ALL'],
          }}
          inputAutocompleteValue={value}
        />
      </InputWrapper>
    </Wrapper>
  );
};
